// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-408b1b2d]{display:flex;min-height:100vh;background:#1c0c32;flex-direction:column;padding-top:64px}@media screen and (min-width: 960px){.layout[data-v-408b1b2d]{padding-top:88px}}.layout__main[data-v-408b1b2d]{flex:1;display:flex;background:#1c0c32;flex-direction:column;justify-content:center}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
